"use client";

import Link from "next/link";
import type { Category } from "@/types";

interface CardCategoryProps {
  category: Category;
  customIcon?: string;
}

// Mapa de ícones Font Awesome por categoria
const getCategoryIcon = (categoryName: string): string => {
  const name = categoryName.toLowerCase();

  if (
    name.includes("restaurante") ||
    name.includes("comida") ||
    name.includes("alimentação") ||
    name.includes("lanchonete") ||
    name.includes("pizzaria") ||
    name.includes("bebidas")
  ) {
    return "fa-utensils";
  }

  if (
    name.includes("saúde") ||
    name.includes("médico") ||
    name.includes("farmácia") ||
    name.includes("clínica") ||
    name.includes("hospital")
  ) {
    return "fa-heart-pulse";
  }

  if (
    name.includes("educação") ||
    name.includes("escola") ||
    name.includes("curso") ||
    name.includes("ensino")
  ) {
    return "fa-graduation-cap";
  }

  if (
    name.includes("serviço") ||
    name.includes("manutenção") ||
    name.includes("reparo") ||
    name.includes("conserto")
  ) {
    return "fa-screwdriver-wrench";
  }

  if (
    name.includes("beleza") ||
    name.includes("estética") ||
    name.includes("salão") ||
    name.includes("cabelo") ||
    name.includes("barbearia")
  ) {
    return "fa-scissors";
  }

  if (
    name.includes("loja") ||
    name.includes("varejo") ||
    name.includes("comércio") ||
    name.includes("mercado")
  ) {
    return "fa-bag-shopping";
  }

  if (
    name.includes("automotivo") ||
    name.includes("carro") ||
    name.includes("moto") ||
    name.includes("veículo")
  ) {
    return "fa-car";
  }

  if (
    name.includes("construção") ||
    name.includes("material") ||
    name.includes("reforma")
  ) {
    return "fa-hammer";
  }

  if (
    name.includes("pet") ||
    name.includes("animal") ||
    name.includes("veterinári")
  ) {
    return "fa-paw";
  }

  if (
    name.includes("hotel") ||
    name.includes("hospedagem") ||
    name.includes("pousada")
  ) {
    return "fa-bed";
  }

  if (
    name.includes("imóvel") ||
    name.includes("imobiliária") ||
    name.includes("aluguel")
  ) {
    return "fa-house";
  }

  if (
    name.includes("advogado") ||
    name.includes("jurídico") ||
    name.includes("advocacia")
  ) {
    return "fa-scale-balanced";
  }

  if (
    name.includes("contabil") ||
    name.includes("contábil") ||
    name.includes("financeiro")
  ) {
    return "fa-calculator";
  }

  if (
    name.includes("tecnologia") ||
    name.includes("informática") ||
    name.includes("computador")
  ) {
    return "fa-laptop";
  }

  if (
    name.includes("esporte") ||
    name.includes("academia") ||
    name.includes("fitness")
  ) {
    return "fa-dumbbell";
  }

  if (
    name.includes("moda") ||
    name.includes("roupa") ||
    name.includes("vestuário")
  ) {
    return "fa-shirt";
  }

  if (
    name.includes("entretenimento") ||
    name.includes("lazer") ||
    name.includes("diversão")
  ) {
    return "fa-masks-theater";
  }

  if (
    name.includes("transporte") ||
    name.includes("frete") ||
    name.includes("mudança")
  ) {
    return "fa-truck";
  }

  if (
    name.includes("foto") ||
    name.includes("fotografia") ||
    name.includes("vídeo")
  ) {
    return "fa-camera";
  }

  // Ícone padrão
  return "fa-store";
};

export default function CardCategory({
  category,
  customIcon,
}: CardCategoryProps) {
  const iconClass = customIcon || getCategoryIcon(category.name);

  return (
    <Link
      href={category.url}
      className="group bg-white rounded-2xl p-6 border border-gray-200 transition-all hover:shadow-xl hover:border-mygreen/50 hover:-translate-y-1 flex flex-col items-center text-center gap-4"
    >
      {/* Ícone com background */}
      <div className="w-16 h-16 rounded-full bg-mygreen/10 flex items-center justify-center text-mygreen group-hover:bg-mygreen group-hover:text-white transition-all group-hover:scale-110 duration-300">
        <i className={`fa-solid ${iconClass} text-2xl`} aria-hidden="true"></i>
      </div>

      {/* Nome da categoria */}
      <div className="flex-1">
        <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-2 line-clamp-2 group-hover:text-mygreen transition-colors">
          {category.name}
        </h3>

        {/* Quantidade */}
        <p className="text-sm text-gray-600">
          {category.qtd} {category.qtd === 1 ? "local" : "locais"}
        </p>
      </div>

      {/* Indicador de ação */}
      <div className="w-6 h-6 rounded-full border-2 border-gray-300 flex items-center justify-center group-hover:border-mygreen group-hover:bg-mygreen transition-all">
        <i
          className="fa-solid fa-chevron-right text-[10px] text-gray-400 group-hover:text-white transition-all group-hover:translate-x-0.5"
          aria-hidden="true"
        ></i>
      </div>
    </Link>
  );
}
